import React, { HTMLProps } from 'react';

import cn from 'classnames';

import cls from './Container.module.scss';

type ContainerProps = HTMLProps<HTMLDivElement>;

export const Container = (props: ContainerProps) => {
	return (
		<div {...props} className={cn(cls.container, props.className)}>
			{props.children}
		</div>
	);
};
